import { TSignRateConfirmationBody } from 'utils/api/marketplace'
import {
  TSourceChannel,
  TSourceSegment,
} from 'apps/fleet-planner/context/track-conversion-source/types'
import { TRateConfirmationFormSchema } from '../schema/RateConfirmationFormSchema'

export const getSignRateConfirmationRequestBody = (
  formValues: TRateConfirmationFormSchema,
  sourceChannel: TSourceChannel | undefined,
  sourceSegment: TSourceSegment | undefined
): TSignRateConfirmationBody => {
  const {
    carrierSignature,
    dispatcherId,
    driverId,
    motorCarrierUser,
    trackingMethod,
    trailerNumber,
    truckNumber,
    vin,
  } = formValues
  const { motorCarrier } = motorCarrierUser
  const { dotNumber: motorCarrierDotNumber, mcNumber: motorCarrierMcNumber } = motorCarrier

  return {
    carrierSignature,
    dispatcherId,
    driverId,
    motorCarrierDotNumber,
    motorCarrierMcNumber,
    trackingMethod,
    trailerNumber,
    truckNumber,
    vin,
    // Track conversion source
    sourceChannel,
    sourceSegment,
  }
}
